'use es6';
'use client';

import { useOnMount } from "../../../../internal/@base-ui/utils/useOnMount";
import { useRefWithInit } from "../../../../internal/@base-ui/utils/useRefWithInit";
import { Timeout } from "../../../../internal/@base-ui/utils/useTimeout";
import { isInteractiveElement } from "../utils.js";
export { isInteractiveElement };
export class HoverInteraction {
  constructor() {
    this.pointerType = undefined;
    this.interactedInside = false;
    this.handler = undefined;
    this.blockMouseMove = true;
    this.performedPointerEventsMutation = false;
    this.pointerEventsScopeElement = null;
    this.pointerEventsReferenceElement = null;
    this.pointerEventsFloatingElement = null;
    this.restTimeoutPending = false;
    this.openChangeTimeout = new Timeout();
    this.restTimeout = new Timeout();
    this.handleCloseOptions = undefined;
    this.dispose = () => {
      this.openChangeTimeout.clear();
      this.restTimeout.clear();
    };
    this.disposeEffect = () => {
      return this.dispose;
    };
  }
  static create() {
    return new HoverInteraction();
  }
}
const pointerEventsMutationOwnerByScopeElement = new WeakMap();
export function clearSafePolygonPointerEventsMutation(instance) {
  if (!instance.performedPointerEventsMutation) {
    return;
  }
  const scopeElement = instance.pointerEventsScopeElement;
  if (scopeElement && pointerEventsMutationOwnerByScopeElement.get(scopeElement) === instance) {
    var _instance$pointerEven, _instance$pointerEven2, _instance$pointerEven3;
    (_instance$pointerEven = instance.pointerEventsScopeElement) === null || _instance$pointerEven === void 0 || _instance$pointerEven.style.removeProperty('pointer-events');
    (_instance$pointerEven2 = instance.pointerEventsReferenceElement) === null || _instance$pointerEven2 === void 0 || _instance$pointerEven2.style.removeProperty('pointer-events');
    (_instance$pointerEven3 = instance.pointerEventsFloatingElement) === null || _instance$pointerEven3 === void 0 || _instance$pointerEven3.style.removeProperty('pointer-events');
    pointerEventsMutationOwnerByScopeElement.delete(scopeElement);
  }
  instance.performedPointerEventsMutation = false;
  instance.pointerEventsScopeElement = null;
  instance.pointerEventsReferenceElement = null;
  instance.pointerEventsFloatingElement = null;
}
export function applySafePolygonPointerEventsMutation(instance, options) {
  const {
    scopeElement,
    referenceElement,
    floatingElement
  } = options;
  const existingOwner = pointerEventsMutationOwnerByScopeElement.get(scopeElement);
  if (existingOwner && existingOwner !== instance) {
    clearSafePolygonPointerEventsMutation(existingOwner);
  }
  clearSafePolygonPointerEventsMutation(instance);
  instance.performedPointerEventsMutation = true;
  instance.pointerEventsScopeElement = scopeElement;
  instance.pointerEventsReferenceElement = referenceElement;
  instance.pointerEventsFloatingElement = floatingElement;
  pointerEventsMutationOwnerByScopeElement.set(scopeElement, instance);
  scopeElement.style.pointerEvents = 'none';
  referenceElement.style.pointerEvents = 'auto';
  floatingElement.style.pointerEvents = 'auto';
}
export function useHoverInteractionSharedState(store) {
  const data = store.context.dataRef.current;
  const instance = useRefWithInit(() => {
    var _data$hoverInteractio;
    return (_data$hoverInteractio = data.hoverInteractionState) !== null && _data$hoverInteractio !== void 0 ? _data$hoverInteractio : HoverInteraction.create();
  }).current;
  if (!data.hoverInteractionState) {
    data.hoverInteractionState = instance;
  }
  useOnMount(data.hoverInteractionState.disposeEffect);
  return data.hoverInteractionState;
}